var app = angular.module('leonardo');

var QuickReportsService = function(BaseRestService) {
  return new BaseRestService('quick-reports', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('quick-reports', false, function(report) {
      report.addRestangularMethod('cloneToWhiteLabel', 'post', 'clone-to-whitelabel');
      return report;
    });
  });
};

app.factory('QuickReportsService', ['BaseRestService', QuickReportsService]);
